import { render, staticRenderFns } from "./OrbitAmountInput.vue?vue&type=template&id=bcd03cfc&scoped=true"
import script from "./OrbitAmountInput.vue?vue&type=script&lang=ts"
export * from "./OrbitAmountInput.vue?vue&type=script&lang=ts"
import style0 from "./OrbitAmountInput.vue?vue&type=style&index=0&id=bcd03cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd03cfc",
  null
  
)

export default component.exports